import * as React from "react"
import type { SVGProps } from "react"
const SvgCloseFullScreen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m10 15.4-5.9 5.9a1 1 0 0 1-.7.27 1 1 0 0 1-.7-.27 1 1 0 0 1-.27-.7q0-.43.27-.7L8.6 14H5a1 1 0 0 1-.71-.29A1 1 0 0 1 4 13q0-.42.29-.71.29-.3.71-.29h6q.42 0 .71.29.3.29.29.71v6q0 .42-.29.71-.29.3-.71.29a1 1 0 0 1-.71-.29A1 1 0 0 1 10 19zm5.4-5.4H19q.42 0 .71.29.3.29.29.71 0 .42-.29.71-.29.3-.71.29h-6a1 1 0 0 1-.71-.29A1 1 0 0 1 12 11V5q0-.42.29-.71.29-.3.71-.29.42 0 .71.29.3.29.29.71v3.6l5.9-5.9a1 1 0 0 1 .7-.27q.43 0 .7.27.27.28.27.7t-.27.7z" />
  </svg>
)
export default SvgCloseFullScreen
